var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"main-content columns is-fullheight"},[_c('Sidebar'),_c('div',{staticClass:"column"},[_c('div',[_c('keep-alive',[_c('router-view')],1)],1)])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }